import React from "react";
import { CompanyProps } from "app/shares/CompanyProps/CompanyProps";
import { CollapsibleText } from "app/layout/CollapsibleText/CollapsibleText";
import { Box } from "app/layout/components";
import { LinkWithArrowRight } from "app/links/LinkWithArrowRight/LinkWithArrowRight";
import { Country } from "app/shares/interfaces";
import { AdTypes } from "app/thirdParty/ads/interfaces";
import { AdWrapper } from "app/thirdParty/ads/AdWrapper";

import "./style.scss";
import { SectionHeader } from "app/layout/SectionHeader/SectionHeader/SectionHeader";

export interface Props {
    name: string;
    description?: string;
    country?: Country;
    industry?: string;
    url?: string;
    wkn: string;
    /** Free Float = Streubesitz */
    freeFloat: number | null;
    equityType: string;
}

/**
 * The component renders the box "Unternehmensprofil"
 * which renders the companyProps and a descriptive text and optionally a link to the companies website.
 */
export const CompanyDetails = ({ name, description, url, ...companyProps }: Props) => {
    return (
        <Box section className="companyDetails">
            <SectionHeader headline={`Stammdaten ${name}`} />
            <CompanyProps {...companyProps} />
            <AdWrapper type={[AdTypes.MREC, AdTypes.MREC_MOBILE]}>
                {description && <CollapsibleText text={description} />}
                {url && <LinkWithArrowRight url={url} title="Unternehmenswebsite" newTab={true} />}
            </AdWrapper>
        </Box>
    );
};
